export const environment = {
  apiUrl: 'https://gateway.qa.juripredis.com/subscription',
  legacyApiUrl: 'https://api.qa.juripredis.com',
  auth0: {
    domain: 'auth-juripredis.eu.auth0.com',
    clientId: 'G3DLvRfHNnTUZQvuoEghBujW3dEbzXld',
    audience: 'subscription.juripredis.com',
  },
};
